import { instance } from "../utils";
import { types } from "./types";
import axios from "axios";
import { triggerNotification } from "../../components";

export const uploadDocument =
  ({ body, user, group }) =>
  dispatch => {
    const url = `/api/documents/uploadDocument`;
    const headers = {
      Authorization: `Bearer ${user.token}`,
      "Content-Type": "multipart/form-data; charset=utf-8"
    };
    dispatch({ type: types.UPLOAD_FILE.START });
    instance
      .post(url, body, { headers })
      .then(response => {
        dispatch({
          type: types.UPLOAD_FILE.SUCCESS,
          payload: response.data,
          group
        });
        triggerNotification({ message: "Successful Upload" });
      })
      .catch(error => {
        dispatch({ type: types.UPLOAD_FILE.ERROR, payload: error.message });
      });
  };

export const updatePermissions =
  (user, orgId, docId, permissions) => dispatch => {
    const url = `/api/documents/updateDocumentPermissions`;
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${user.token}`
    };
    const body = {
      docId,
      userPermissions: permissions
    };
    dispatch({ type: types.UPDATE_DOCUMENT_PERMISSIONS.START });
    instance
      .post(url, body, { headers })
      .then(response => {
        dispatch({ type: types.UPDATE_DOCUMENT_PERMISSIONS.SUCCESS });
        dispatch(getDocumentsByObligations(user, orgId));
      })
      .catch(error => {
        dispatch({ type: types.UPDATE_DOCUMENT_PERMISSIONS.ERROR });
      });
  };

export const getDocumentsByObligations = (user, orgId) => dispatch => {
  const url = `/api/documents/${orgId}/${user.userId}/getObligationsDocuments`;
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${user.token}`
  };
  dispatch({ type: types.SET_OBLIGATION_DOCUMENTS.START });
  dispatch({ type: "SET_LOADING_PERMISSIONS", payload: true });
  instance
    .get(url, { headers })
    .then(response => {
      dispatch({
        type: types.SET_OBLIGATION_DOCUMENTS.SUCCESS,
        payload: response.data
      });
    })
    .catch(error =>
      dispatch({
        type: types.SET_OBLIGATION_DOCUMENTS.ERROR,
        payload: error.message
      })
    )
    .finally(() => dispatch({ type: "SET_LOADING_PERMISSIONS", payload: false }));
};

export const getDocumentsByLaws = (user, orgId) => dispatch => {
  const url = `/api/documents/${orgId || "0"}/${user.userId}/getLawDocuments`;
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${user.token}`
  };
  dispatch({ type: types.SET_LAW_DOCUMENTS.START });
  instance
    .get(url, { headers })
    .then(response => {
      dispatch({
        type: types.SET_LAW_DOCUMENTS.SUCCESS,
        payload: response.data
      });
    })
    .catch(error =>
      dispatch({
        type: types.SET_LAW_DOCUMENTS.ERROR,
        payload: error.message
      })
    );
};

export const downloadDocument =
  ({ docId, user, callback }) =>
  dispatch => {
    return new Promise((resolve, reject) => {
      const url = `/api/documents/${docId}/downloadDocument`;
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${user.token}`
      };

      const downloadRequestHeaders = {
        responseType: "arraybuffer",
        headers: {
          Authorization: `Bearer ${user.token}`,
          "Content-Type": "application/json",
          Accept: `application/pdf`
        }
      };
      dispatch({ type: types.DOWNLOAD_FILE.START });
      instance
        .get(url, downloadRequestHeaders)
        .then(response => {
          dispatch({ type: types.DOWNLOAD_FILE.SUCCESS });
          const blob = new Blob([response.data], { type: "application/pdf" });
          const url = URL.createObjectURL(blob);

          const contentDisposition = decodeURI(
            response.headers?.["content-disposition"]
          );
          const filenameMatch =
            contentDisposition && contentDisposition.match(/filename="(.+)"/);
          let filename = "";
          if (filenameMatch && filenameMatch.length > 1) {
            filename = filenameMatch[1];
          }

          if (filename) {
            callback(url, filename);
          } else {
            callback(url);
          }
          resolve();
        })
        .catch(error => {
          dispatch({
            type: types.DOWNLOAD_FILE.ERROR,
            payload: error.message
          });
          triggerNotification({
            message: "Error",
            description: `Couldn't download file.`,
            status: "Error"
          });
          reject(error);
        });
    });
  };

export const deleteDocument =
  (obligation_id, doc_id, filename, orgId, user) => dispatch => {
    const url = `/api/documents/deleteDocument`;
    const body = { obligation_id, doc_id, filename };

    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${user.token}`
    };
    dispatch({ type: types.DELETE_FILE.START });
    instance
      .post(url, body, { headers })
      .then(response => {
        dispatch({
          type: types.DELETE_FILE.SUCCESS
        });
        dispatch(getDocumentsByObligations(user, orgId));
      })
      .catch(error => {
        dispatch({
          type: types.DELETE_FILE.ERROR,
          payload: error.message
        });
        triggerNotification({
          message: "Error",
          description: `Couldn't delete file.`,
          status: "Error"
        });
      });
  };

export const addDoc = (id) =>dispatch => {
  dispatch({
    type: "ADD_INTERNAL_DOCUMENT_KEY",
    payload: id 
  });
}
